module.exports = __webpack_public_path__ + "ipetbooking/admin/img/ga_2.fb4b944a.jpg";